import * as yup from "yup";

export const checkoutFormSchema = yup.object({
  firstname: yup.string().required("First name is required"),
  lastname: yup.string().required("Last name is required"),
  phone: yup.string().nullable(),
  email: yup
    .string()
    .email("Invalid email address")
    .required("Email is required"),
  message: yup.string().nullable(),
});
